var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_4641f9e6"]},_vm.$listeners),[_c('div',[_c('cube-button',{on:{"_click":_vm.showPickerWithSetTime}},[_vm._v("Use setTime")]),_c('cube-time-picker',{ref:"__mpx_ref_picker__"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }